require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-soumya-rajan.json") })
        }
      }, "path---insights-soumya-rajan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-soumya-rajan!./.cache/json/insights-soumya-rajan.json
// module id = 1146
// module chunks = 231608221292675